import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import useConfig from '../../hooks/useConfig';
import shippingBagIcon from '../../assets/images/ic_shoppingbag.png';
import orderlistIcon from "../../assets/images/ic_myorder.png";
var cls = 'cart';
var Cart = function Cart(_ref) {
  var count = _ref.count,
    onClickCart = _ref.onClickCart,
    onClickOrderList = _ref.onClickOrderList,
    visible = _ref.visible,
    className = _ref.className;
  var _useConfig = useConfig(),
    createNamespace = _useConfig.createNamespace,
    prefixCls = _useConfig.prefixCls;
  var classes = classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls, prefixCls), className);
  return visible ? _jsxs("div", Object.assign({
    className: classes
  }, {
    children: [_jsx("div", Object.assign({
      className: "cart-section",
      onClick: onClickCart
    }, {
      children: _jsxs("div", Object.assign({
        className: "icon-container"
      }, {
        children: [count && _jsx("div", Object.assign({
          className: "cart-count"
        }, {
          children: count
        })), _jsx("img", {
          src: shippingBagIcon,
          alt: "cart"
        })]
      }))
    })), _jsx("div", Object.assign({
      className: "order-list-icon",
      onClick: onClickOrderList
    }, {
      children: _jsx("div", Object.assign({
        className: "icon-container"
      }, {
        children: _jsx("img", {
          src: orderlistIcon,
          alt: "order list"
        })
      }))
    }))]
  })) : null;
};
export default Cart;